export default {"src":"/_next/static/media/box-feeding-guide.41ad67b5.svg","height":71,"width":179,"blurWidth":0,"blurHeight":0};